// Material 3 Divider Component
// Aligned with Google Material Web (material-components/material-web/docs/components/divider.md)
(function () {
  const { Divider: MuiDivider } = MaterialUI;

  function Divider({
    inset = false,
    orientation = 'horizontal',
    sx = {},
    ...props
  }) {
    const theme = MaterialUI.useTheme();
    const isDark = theme?.palette?.mode !== 'light';

    return (
      <MuiDivider
        orientation={orientation}
        sx={{
          borderColor: 'var(--m3-outline-variant)',
          my: orientation === 'horizontal' ? (inset ? 1 : 0.75) : 0,
          mx: orientation === 'vertical' ? 1 : (inset ? 1.5 : 0),
          ...sx
        }}
        {...props}
      />
    );
  }

  window.Components = window.Components || {};
  window.Components.Divider = Divider;
})();
